/** @jsxImportSource @emotion/react */
import { useTranslation } from 'react-i18next'
import { I18N_REPORT_NS } from '../../../i18n'
import { Space, Typography } from 'antd'
import { css } from '@emotion/css'
import { renderReportPeriod } from '..'
import { HtmlText } from '../../../components/display/htmlText'

const vertSpaceProps = { direction: 'vertical', style: { width: '100%' } }

export const Runway = ({ reports }) => {
	const { t } = useTranslation([I18N_REPORT_NS])
	return (
		<Space {...vertSpaceProps} size={0}>
			<Typography.Text strong className={css({ fontSize: 14, lineHeight: 1 })}>
				{t('runway_title')}
			</Typography.Text>
			<Space direction='vertical'>
				{reports?.map(report => (
					<Space key={report.id ?? report.quarter} size={8}>
						<Typography.Text strong className={css({ fontSize: 12 })}>
							{report.quarter && `${renderReportPeriod(report)}:`}
						</Typography.Text>
						<Typography.Text className={css({ fontSize: 12 })}>
							<HtmlText value={report.run_way} />
						</Typography.Text>
					</Space>
				))}
			</Space>
		</Space>
	)
}
